import { UserType } from '../types/UserType'
import { UserGenericTypes } from '../enums/UserGenericTypes'
import { UserDto } from '../types/UserDto'
import { OneOrMore } from '@internal-libraries/kheops-ui-lib'
import { UserAPIAdapter } from '../adapters/UserAPIAdapter'

export class User {
    public readonly practitionerTypeList = [
        UserGenericTypes.DOCTOR,
        UserGenericTypes.SURGEON,
        UserGenericTypes.ANAESTHETIST,
        UserGenericTypes.DENTIST,
    ]

    public id!: number
    public userUsername!: string
    public userPassword!: string
    public userFirstName?: string
    public userLastName!: string
    public userType!: UserGenericTypes
    public color?: string
    public initials?: string
    public userSex?: string
    public shortview?: string
    public view?: string

    public constructor(data: UserType) {
        Object.assign(this, data)
    }

    public get fullName(): string {
        return `${this.userLastName} ${this.userFirstName}`
    }

    public get fullNameWithInitial(): string {
        const names = [this.userLastName]
        if (this.userFirstName) {
            names.push(`${this.userFirstName?.charAt(0)}.`)
        }
        return names.join(' ')
    }

    public get isNurse(): boolean {
        return this.userType === UserGenericTypes.NURSE
    }

    public get isPractitioner(): boolean {
        return this.practitionerTypeList.includes(this.userType)
    }

    public get isPharmacist(): boolean {
        return this.userType === UserGenericTypes.PHARMACIST
    }

    public get label(): string {
        return this.view ?? `${this.userFirstName} ${this.userLastName}`
    }

    public static convertDtoToUserList(refUsers?: OneOrMore<UserDto>): User[] {
        if (refUsers) {
            return (Array.isArray(refUsers) ? refUsers : [refUsers]).map(new UserAPIAdapter().createClass)
        }
        return []
    }

    public toDto(): UserDto {
        return {
            id: this.id,
            user_username: this.userUsername,
            user_password: this.userPassword,
            user_first_name: this.userFirstName,
            user_last_name: this.userLastName,
            user_type: this.userType,
            user_sexe: this.userSex,
            _ref_mediuser: {
                id: this.id,
                color: this.color,
                initials: this.initials,
            },
            _shortview: this.shortview,
            _view: this.view,
        }
    }
}
